import React from 'react';
import { SampleCarousel } from './SampleCarousel';
export function SolutionSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-351">
      <div className="max-w-4xl mx-auto text-center" data-id="element-352">
        <h2 className="text-[20px] font-black mb-4 text-[#5B3FA0]" data-id="element-353">
          LA SOLUCIÓN: MEGAPACK ESI SECUNDARIA
        </h2>

        <p className="text-xl md:text-2xl font-medium text-gray-700 mb-6 max-w-3xl mx-auto" data-id="element-354">
          Un cuadernillo completo diseñado para acompañarte durante todo el
          ciclo lectivo. Cada tema incluye actividades listas para imprimir,
          pensadas especialmente para estudiantes de secundaria. Simplemente
          elegís el tema que necesitás y la clase ya está preparada.
        </p>

        <SampleCarousel data-id="element-355" />

        <p className="text-2xl font-black text-gray-900" data-id="element-356">
          <span className="px-2 text-[#2E9E8F] bg-[#FFFFFF]" data-id="element-357">
            Sin perder tiempo. Sin empezar desde cero. Sin improvisar.
          </span>
        </p>
      </div>
    </section>;
}